import { PailMinusOutlineIcon } from './PailMinusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 599354BE-5249-40F9-8E62-466F89203E5B
 * name pail-minus-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-minus-outline.svg
 * tags
 */
export const BucketMinusOutlineIcon = PailMinusOutlineIcon;
export default BucketMinusOutlineIcon